import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { Stock } from "../state/types"

export const useStockActions = () => {
    const saveActions = useSaveActions()

    const saveStock = (stock: Stock) => {
        const { save } = saveActions()
        return save(TableName.STOCK, stock) as Promise<Stock>
    }

    const saveStockList = (stockList: Stock[]) => {
        const { saveMultiple } = saveActions()
        return saveMultiple(TableName.STOCK, stockList) as Promise<Stock[]>
    }

    const removeStock = (id: string) => {
        const { remove } = saveActions()
        return remove(TableName.STOCK, id)
    }

    const removeStockList = (ids: string[]) => {
        const { removeMultiple } = saveActions()
        return removeMultiple(TableName.STOCK, ids)
    }

    return {
        saveStock,
        saveStockList,
        removeStock,
        removeStockList
    }
}
